import { AfterViewInit, Directive, ElementRef, HostListener, OnInit } from "@angular/core";
import { NgModel } from "@angular/forms";
import { BehaviorSubject } from "rxjs";

@Directive({
    selector: 'form',
    providers: [NgModel]
})
export class HandheldFormDirective implements AfterViewInit, OnInit {

	ngOnInit(): void {
		this.setInputs();
	}

	ngAfterViewInit(): void {
		// this.form.nativeElement.tabIndex = -1;
		// this.form.nativeElement.focus();
		setTimeout(() => {
			this.handleInputEnter();
			if (this.focusable.length > 0 && !this.focusable[0].disabled) {
				this.focusable[0].disabled = false;
				this.makeFocusWithoutKeyboard(this.focusable[0]);
			}
		}, 250)

	}

	constructor(private form: ElementRef<HTMLFormElement>, private ngModel: NgModel) {
		this.form = form;
		this.ngModel = ngModel;
	}

	private readonly = false;
	automaticFocus = false;

	private focusable: Array<HTMLInputElement> = [];

	private lastFocused: HTMLInputElement;

	private getInputFilter = ((element: HTMLInputElement) => {
		element.readOnly = this.readonly;
		//check for visibility while always include the current activeElement
		return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
	}).bind(this);

	private setReadOnlyLoop = ((element: HTMLInputElement) => {
		element.readOnly = this.readonly;
	}).bind(this);

	public triggerValueEnter: BehaviorSubject<string> = new BehaviorSubject("");



	@HostListener("window:input", ["$event"])
	private handleInput(event: InputEvent) {
		this.handleInputEnter(event);
	}
	// Desligar para não ter duplicação no tab de input
	// Serve como debug para desktop
	// @HostListener("window:keydown.enter", ["$event"])
	// handleEnterInput(event : Event){
	//   this.handleEnter();
	// }

	@HostListener("window:keydown.enter", ["$event"])
	private handleEnterDesktop() {
		if (!(navigator as any).userAgentData.mobile) {
			console.log("entrou em handle pro desktop");
			this.handleInputEnter();
		}
	}

	private handleInputEnter(event?: InputEvent) {
		this.setInputs();

		let index = this.getActualIndex();
		let input = this.focusable[index] as HTMLInputElement;
		if (event && event.data) this.ngModel.update.next(event.data.trim());

		this.lastFocused = this.focusable[index];

		if (input && input.id) this.triggerValueEnter.next(input.id);

		if (document.activeElement && this.automaticFocus) {
			if (index > -1) {
				let nextElement = this.focusable[index + 1] || this.focusable[0];
				// if(!focusable[index + 1]){
				//   //this.form.nativeElement.requestSubmit();
				// }
				if (input.attributes.getNamedItem("handheldEnter")) {
					input.attributes.getNamedItem("handheldEnter").value
				}
				this.makeFocusWithoutKeyboard(nextElement)

			}
		}
	}

	nextInput() {
		setTimeout(() => {
			let index = this.getActualIndex();
			if (index > -1) {
				let nextElement = this.focusable[index + 1] || this.focusable[0];
				if (!this.focusable[index + 1]) this.focusable[0].disabled = false;
				this.makeFocusWithoutKeyboard(nextElement)
			}
		}, 150)
	}

	private makeFocusWithoutKeyboard(nextElement: HTMLInputElement) {
		this.readonly = true;
		nextElement.readOnly = this.readonly;
		nextElement.focus();
		setTimeout(() => {
			this.readonly = false;
			Array.prototype.forEach.call(this.form.nativeElement.querySelectorAll("input"), this.setReadOnlyLoop);
		}, 100);
	}

	private setInputs() {
		this.focusable = Array.prototype.filter.call(this.form.nativeElement.querySelectorAll("input"), this.getInputFilter);
	}

	private getActualIndex(): number {
		return this.focusable.indexOf(document.activeElement as HTMLInputElement);
	}

	public returnFocusPreviousInput() {
		this.makeFocusWithoutKeyboard(this.lastFocused)
	}
	public focusOnIndex(index: number) {
		this.makeFocusWithoutKeyboard(this.focusable[index]);
	}

	public focusById(id: string) {
		this.focusable.filter((input) => {
			input.id == id ? input.focus() : false;
		})
	}
}

